// 移除loading效果
function closeLoading() {
  document.getElementById('loadingDiv').style.display = 'none'
}
// 展示loading效果
function showLoading() {
  // 在页面未加载完毕之前显示的loading Html自定义内容
  const elemDiv = document.createElement('div')
  const _LoadingHtml = '<div id="loadingDiv" style="display: none; ">' +
    '<div id="over" style=" position: absolute;top: 0;' +
    'left: 0; width: 100%;height: 100%; background-color: #f5f5f5;opacity:0.5;' +
    'z-index: 1000;"></div><div id="layout" style="position: absolute;top: 40%; left: 40%;width: 20%; height: 20%;  z-index: 1001;text-align:center;">' +
    '<img src="/static/images/icons/lg.gif" /></div></div>'

  elemDiv.innerHTML = _LoadingHtml
  // 呈现loading效果
  document.body.appendChild(elemDiv)
  document.getElementById('loadingDiv').style.display = 'block'
}

export {
  showLoading, closeLoading,
}



//////////////////
// WEBPACK FOOTER
// ./static/loading.js
// module id = 623
// module chunks = 58